import axios from "@/utils/axios";
/*

    운임계산관련 API set 입니다.

*/

export function useCharge() {
  /*
    퀵 운임 계산 API 
  */
  const chargeQuick = async (payload: api.charge.quick.payload) => {
    try {
      const { data } = await axios.post<api.charge.quick.response>(
        "/charge/quick",
        payload
      );
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };
  /*
    퀵 - 화물 운임 계산 API 
  */
  const chargeQuickFreight = async (payload: api.charge.freightPayload) => {
    try {
      const { data } = await axios.post<api.charge.quick.response>(
        "/charge/freight-quick",
        payload
      );
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /**
   * 택배 운임 계산 API
   */
  const chargeParcel = async (payload: api.charge.parcel.payload) => {
    try {
      const { data } = await axios.post<api.charge.parcel.response>(
        "/charge/parcel",
        payload
      );
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /**
   * 다량택배접수 운임 API
   */
  const chargeMassParcel = async (payload: api.charge.mass.parcel.payload) => {
    try {
      const { data } = await axios.post<api.charge.mass.parcel.response>(
        "/charge/mass/parcel",
        payload
      );
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /**
   * 등기요금 조회 API
   */
  const chargeRegisteredMail = async (payload: { category: string }) => {
    try {
      const { data } = await axios.post<api.charge.mail.response>(
        "/charge/mail",
        payload
      );
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  return {
    chargeQuick,
    chargeQuickFreight,
    chargeParcel,
    chargeMassParcel,
    chargeRegisteredMail,
  };
}
